<div mat-menu-item
  >@if (icon) {
  <campus-icon data-cy="notification-icon" [svgIcon]="icon" class="ui-notification__icon"></campus-icon>
}
@if (person) {
  <campus-person-badge
    data-cy="notification-badge"
    class="ui-notification__badge"
    [person]="person"
    align="left"
    size="medium"
    [showText]="false"
  ></campus-person-badge>
}
<div class="ui-notification__body">
  @if (titleText) {
    <div class="ui-notification__title" data-cy="notification-title">{{ titleText }}</div>
  }
  <div class="ui-notification__text" data-cy="notification-text"
    >{{ notificationText }}@if (accented && link) {
    <span>&nbsp;&rarr; <span>Lees meer&hellip;</span></span>
  }
</div>
</div>
<div class="ui-notification__end">
  @if (notificationDate) {
    <div class="ui-notification__date">{{ notificationDate | humanDateTime }}</div>
  }

  <div class="ui-notification__buttons">
    <ng-content select="campus-button campus-icon"></ng-content>
  </div>
</div>
</div>
